document.addEventListener('DOMContentLoaded', function() {
  // Select the blog article container with the class 'blog__article'
  var blogContent = document.querySelector('.blog__article');

  if (blogContent) {
    // Match placeholders like [youtube-video id="..." img="..."]
    var placeholders = blogContent.innerHTML.match(/\[youtube-video id="(.*?)" img="(.*?)"\]/g);

    if (placeholders) {
      placeholders.forEach(function(placeholder) {
        // Extract video ID and image source from the placeholder
        var videoId = placeholder.match(/id="(.*?)"/)[1];
        var imgSrc = placeholder.match(/img="(.*?)"/)[1];

        // Create the YouTube snippet dynamically
        var youtubeSnippet = `
          <div style="position: relative; width: 100%; max-width: 1060px; margin: 0 auto;">
            <!-- Custom Image Cover -->
            <div style="position: relative;">
              <!-- Play Button Overlay -->
              <div id="playButtonOverlay_${videoId}" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 2; pointer-events: none;">
                <img src="https://upload.wikimedia.org/wikipedia/commons/b/b8/YouTube_play_button_icon_%282013%E2%80%932017%29.svg" alt="Play Button" width="70" height="50" style="width: 70px; height: 50px;">
              </div>
              <!-- Image Cover with Click Event -->
              <img src="${imgSrc}" alt="Video Cover" width="1060" height="596" style="width: 100%; display: block; cursor: pointer;" onclick="playVideo('${videoId}');">
            </div>
            <!-- YouTube Video Iframe (Initially Hidden) -->
            <div id="videoIframe_${videoId}" style="display: none; position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden;">
              <iframe id="youtubeIframe_${videoId}" src="https://www.youtube.com/embed/${videoId}?rel=0&showinfo=0" title="YouTube video" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: 0;" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </div>
          </div>
        `;

        // Replace the placeholder with the YouTube snippet
        blogContent.innerHTML = blogContent.innerHTML.replace(placeholder, youtubeSnippet);
      });
    }
  }

  // Define the playVideo function globally
  window.playVideo = function(videoId) {
    // Hide the image cover and play button
    var coverImage = document.querySelector('img[alt="Video Cover"][onclick="playVideo(\'' + videoId + '\');"]');
    if (coverImage) {
      coverImage.style.display = 'none';
    }

    var playButton = document.getElementById('playButtonOverlay_' + videoId);
    if (playButton) {
      playButton.style.display = 'none';
    }

    // Show the iframe container and autoplay the video
    var iframeContainer = document.getElementById('videoIframe_' + videoId);
    if (iframeContainer) {
      iframeContainer.style.display = 'block';
    }

    var iframe = document.getElementById('youtubeIframe_' + videoId);
    if (iframe) {
      iframe.src += "&autoplay=1";
    }
  };
});


////////////////////////////////////////////////////
//new code for [separator]
////////////////////////////////////////////////////

document.addEventListener('DOMContentLoaded', function() {
  // Select the blog article container with the class 'blog__article'
  var blogContent = document.querySelector('.blog__article');

  if (blogContent) {
    // Match placeholders like [separator] or [separator X Y]
    var separatorPlaceholders = blogContent.innerHTML.match(/\[separator(?: (\d+) (\d+))?\]/g);

    if (separatorPlaceholders) {
      separatorPlaceholders.forEach(function(placeholder) {
        // Extract margin values, or use default values if not provided
        var margins = placeholder.match(/\[separator(?: (\d+) (\d+))?\]/);
        var marginTop = margins[1] ? margins[1] : 50; // Default margin-top value
        var marginBottom = margins[2] ? margins[2] : 50; // Default margin-bottom value

        // Create the separator div dynamically
        var separatorDiv = `
          <div class="separator" style="margin-top:${marginTop}px !important; margin-bottom:${marginBottom}px !important; width:80%; height:2px; background:black; display:block; margin:auto;"></div>
        `;

        // Replace the placeholder with the separator div
        blogContent.innerHTML = blogContent.innerHTML.replace(placeholder, separatorDiv);
      });
    }
  }
});




